<template>
  <div class="payment">
    <vue-element-loading :active="isLoadingActive" spinner="bar-fade-scale" color="#444" size="70" :is-full-screen="true"/>
    <div id="pix-identifier">
      <div class="container">
        <div class="d-flex justify-content-between align-items-center">
          <div class="title" v-if="transaction">{{ transactionTitle }}</div>
          <div class="amount">{{ transaction ? transaction.amount : '' }}</div>
        </div>
      </div>
    </div>
    <div id="pix-description">
      <div class="container text-center">
        <img :src="require('@/assets/images/pix-logo.png')" class="pix-logo" alt="pix-logo" />
        <h1>
          <span class="d-none d-sm-block">
            Escaneie o QRCode PIX ou copie o código e realize o pagamento no seu app de pagamento preferido
          </span>
          <span class="d-block d-sm-none">
            Copie o código e realize o pagamento no seu app de pagamento preferido
          </span>
        </h1>
        <p v-if="transaction" class="description_pharagraph">{{ transactionDescription }}</p>
      </div>
    </div>
    <div class="container">
      <div class="qrcode-box d-none d-sm-block py-2" v-if="qrCodeImage">
        <card>
          <template v-slot:title>
            Pague seu PIX via QR Code
          </template>
          <template v-slot:content>
            <div class="row">
              <div class="col-sm text-center text-sm-left">
                <img id="qrcode" :src="qrCodeImage" alt="qrcode" />
              </div>
              <div class="col-sm">
                <step-list title="Como realizar o pagamento" :steps="instructionsSteps.qrCode" />
              </div>
            </div>
          </template>
        </card>
      </div>
      <div class="code-box py-2" v-if="transaction && transaction.copyCode">
        <card>
          <template v-slot:title>
              <span class="d-none d-sm-block">
                Ou pague seu PIX com código copia e cola
              </span>
              <span class="d-block d-sm-none">
                Pague seu PIX via Copia e cola
              </span>
          </template>
          <template v-slot:content>
              <copy-button :value="transaction.copyCode" @copied-content="toggleModal">
                Copiar código PIX
              </copy-button>
              <div class="instruction">Utilize o código para realizar o pagamento via PIX</div>
          </template>
        </card>
      </div>
      <div id="copy-code-instructions" class="d-sm-none">
        <card>
          <template v-slot:content>
            <step-list :steps="instructionsSteps.copyCode" />
          </template>
        </card>
      </div>
    </div>
    <modal id="copy-code-modal" ref="copyCodeModal">
      <template v-slot:header>
        <div id="copied-copy-header">
          <img :src="require('@/assets/images/pix-logo.png')" class="pix-logo" alt="pix-logo" />
          <h4>Código copiado!</h4>
        </div>
      </template>
      <div class="px-2 px-sm-5">
        <step-list :steps="instructionsSteps.copyCode" />
        <div id="copy-code-actions">
          <button
            class="btn btn-primary btn-lg"
            type="button"
            @click="toggleModal()">Entendi</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { getQRCode } from '@/integrations/pixie/client'

import StepList from '../components/StepList.vue'
import Card from '../components/Card.vue'
import CopyButton from '../components/CopyButton.vue'
import Modal from '../components/Modal.vue'
import VueElementLoading from 'vue-element-loading'

export default {
  components: {
    StepList,
    Card,
    CopyButton,
    Modal,
    VueElementLoading
  },
  data () {
    return {
      transaction: null,
      instructionsSteps: {
        qrCode: [
          'Abra o app onde você possui PIX',
          'Clique em PIX',
          'Escaneie o QRCode'
        ],
        copyCode: [
          'Abra o app do seu banco ou instituição financeira e selecione Pix',
          'Selecione a opção Pix copia e cola',
          'Cole o código, confirme as informações e finalize a compra'
        ]
      },
      defaultTransactionDescription: 'Após a realização do pagamento, seu benefício estará disponível em até 24 horas.',
      loadingActive: true
    }
  },
  computed: {
    qrCodeImage () {
      return this.transaction?.qrCodeImage?.getImage()
    },
    transactionTitle () {
      const additionalInformation = this.transaction.additionalInformation.find(ad => {
        return ad.name === 'LANDING_PAGE_TITLE'
      })
      return additionalInformation ? additionalInformation.value : ''
    },
    transactionDescription () {
      const additionalInformation = this.transaction.additionalInformation.find(ad => {
        return ad.name === 'LANDING_PAGE_DESCRIPTION'
      })
      return additionalInformation ? additionalInformation.value : this.defaultTransactionDescription
    },
    isLoadingActive () {
      return this.loadingActive
    }
  },
  methods: {
    injectTransaction (transaction) {
      this.transaction = transaction
    },
    toggleModal () {
      this.$refs.copyCodeModal.toggleModal()
    }
  },
  mounted () {
    getQRCode(this.$route.params.transactionId).then(transaction => {
      if (transaction.is_paid) {
        this.$router.push('/paid')
        return
      }
      if (transaction.is_expired) {
        this.$router.push({ name: 'expired', params: { rawAmount: transaction.rawAmount } })
        return
      }
      this.injectTransaction(transaction)
      this.loadingActive = false
    }).catch(error => {
      console.log(error.name === 'TransactionNotFoundError')
      this.$router.push('/notfound')
    })
  }
}
</script>

<style lang="scss">
#pix-identifier {
    padding: 10px 0;
    background-color: #FFF;
    border-bottom: 1px solid #ebebeb;

    .container {
        .title {
            text-transform: uppercase;
        }

        .amount {
            border-radius: 5px;
            padding: 5px;
            background-color: #ebebeb;
        }
    }
}

#pix-description {
    padding: 24px 0;
    background-color: #FFF;
    box-shadow: 0px 1px 0px #00000014;

    .container {
        padding: 0 20px;

        img.pix-logo {
            width: 40px;
            height: auto;
            margin-bottom: 16px;
        }

        h1 {
            font-size: 24px;
            margin-bottom: 15px;
        }

        p.description_pharagraph {
            color: #666666;
            margin: 0;
        }

        :last-child {
            margin-bottom: 26px;
        }
    }
}

#copy-code-modal {
  .modal-header {
    justify-content: center;

    #copied-copy-header {
      text-align: center;

      img.pix-logo {
        width: 40px;
        height: auto;
        margin-bottom: 9px;
      }

      h4 {
        margin: 0;
      }
    }
  }

  .modal-body {
    #copy-code-actions {
      text-align: center;
      margin-top: 20px;
    }
  }
}
</style>
